module.exports = __webpack_public_path__ + "img/play-button-arrowhead.20059371.svg";